import Favorite from "@mui/icons-material/Favorite";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import SmallIconButton from "components/atoms/Button/SmallIconButton";
import React from "react";


const Body = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const UserSection = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "start",
  gap: "12px",
}));

const EmptySection = styled(Box)(({ theme }) => ({
  width: "45px",
}));

const DetailSection = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  justifyContent: "start",
  gap: "7px",
}));

const NameSection = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "start",
  gap: "20px",
}));

export const FavorSection = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "self-start",
}));

const NameText = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  color: "#ffffff",
  fontWeight: "500",
}));

const CommitText = styled(NameText)(({ theme }) => ({
  fontWeight: "bold",
}));

const AnnouncementText = styled(NameText)(({ theme }) => ({
  fontWeight: "initial",
  fontSize: "12px",
}));

const SmallText = styled(NameText)(({ theme }) => ({
  fontSize: "12px",
  color: "#c1c1c1",
  fontWeight: "initial",
}));

const label = { inputProps: { "aria-label": "Checkbox demo" } };

interface commentlistsProps {
  isBig: boolean;
  isDev?: boolean;
  imgSize?: string;
  name: string;
  comment?: string;
  answer?: string;
  favor?: string;
  see?: string;
  announcement?: string;
}
const CommentLists: React.FC<commentlistsProps> = ({
  isBig,
  isDev,
  imgSize,
  name,
  comment,
  answer,
  favor,
  see,
  announcement,
}) => {
  const user0 = require('assets/Profile/buku_default_avatar.png');
  return (
    <Body>
      <UserSection>
        {isBig ? <></> : <EmptySection />}
        {imgSize === "big" ? (
          <img
            src={user0}
            style={{ width: "45px", height: "45px" }}
            alt={"user"}
          />
        ) : (
          <img
            src={user0}
            style={{ width: "35px", height: "35px", paddingTop: "4px" }}
            alt={"user"}
          />
        )}
        <DetailSection>
          <NameSection>
            <NameText>{name}</NameText>{" "}
            {isDev ? (
              <SmallIconButton
                type={"dev"}
                isClicked={true}
                color={"yellow"}
                text={"developer"}
              />
            ) : (
              <></>
            )}{" "}
          </NameSection>
          {comment ? <CommitText>{comment}</CommitText> : <></>}
          {announcement ? (
            <AnnouncementText>{announcement}</AnnouncementText>
          ) : (
            <></>
          )}
          {answer ? <SmallText>{answer}th Answer</SmallText> : <></>}
          {see ? <SmallText>See answers({see})</SmallText> : <></>}
        </DetailSection>
      </UserSection>
      {favor ? (
        <FavorSection style={{ alignSelf: "flex-start" }}>
          <Checkbox
            style={{ padding: "unset", paddingBottom: "6px" }}
            {...label}
            icon={<FavoriteBorderOutlinedIcon style={{ color: "#c1c1c1" }} />}
            checkedIcon={<Favorite style={{ color: "#ddb930" }} />}
          />
          <SmallText>{favor}</SmallText>
        </FavorSection>
      ) : (
        <></>
      )}
    </Body>
  );
};

export default CommentLists;
